
// import React, { useState } from 'react';
// import axios from 'axios';
// import { CognitoUser } from 'amazon-cognito-identity-js';
// import { userPool } from '../cognito/UserPool';
// import Env from '../runtimeEnv';

// function ResetPasswordForm({ setFormType }) {
//   const [email, setEmail] = useState('');
//   const [verificationCode, setVerificationCode] = useState('');
//   const [newPassword, setNewPassword] = useState('');
//   const [error, setError] = useState('');
//   const [formState, setFormState] = useState('resetRequest'); // Control flow (resetRequest, resetConfirm)

//   // Handle reset password request
// const handleResetRequest = async (e) => {
//   e.preventDefault();
//   setError('');

//   try {
//     const response = await axios.post(`${Env.REACT_APP_PYTHON_API_URL}/api/forgot-password`, {
//       email,
//     });

//     if (response.data.newTemporaryPasswordSent) {
//       console.log('Temporary password sent to email');
//       setError('Your temporary password has been sent to your email.');

//       // Redirect to login form for expired users
//       setFormType('login');
//     } else {
//       console.log('Reset code sent to email');
//       setFormState('resetConfirm'); // Proceed to enter confirmation code and new password
//     }
//   } catch (err) {
//     console.error('Error in password reset:', err);
//     setError(`Failed to send reset code: ${err.response?.data?.message || err.message}`);
//   }
// };


//   // Handle reset password confirmation (for normal reset flow)
//   const handleResetConfirm = (e) => {
//     e.preventDefault();
//     setError('');

//     const cognitoUser = new CognitoUser({
//       Username: email,
//       Pool: userPool,
//     });

//     cognitoUser.confirmPassword(verificationCode, newPassword, {
//       onSuccess: () => {
//         console.log('Password reset successful');
//         setFormType('login'); // Return to login form
//       },
//       onFailure: (err) => {
//         console.error('Error resetting password:', err);
//         setError(`Failed to reset password: ${err.message}`);
//       },
//     });
//   };

//   return (
//     <div className="bg-black bg-opacity-80 p-8 rounded-3xl shadow-lg w-[350px] text-white text-center">
//       {formState === 'resetRequest' ? (
//         <>
//           <h2 className="text-2xl font-bold mb-6">Reset Password</h2>
//           <form onSubmit={handleResetRequest} className="space-y-2">
//             <div className="relative">
//               <input
//                 type="email"
//                 value={email}
//                 onChange={(e) => setEmail(e.target.value)}
//                 placeholder="Enter your email"
//                 className="w-full p-3 bg-transparent border border-gray-400 rounded-full text-white text-sm placeholder-gray-500 focus:outline-none focus:border-[#22AAEE]"
//                 required
//               />
//             </div>
//             {error && <p className="text-red-500">{error}</p>}
//             <button
//               type="submit"
//               className="w-full py-3 border border-[#22AAEE] text-[#22AAEE] font-bold rounded-full transition duration-200 hover:bg-[#22AAEE] hover:text-white"
//             >
//               Send Reset Code
//             </button>
//           </form>
//           <p
//             className="mt-4 text-sm cursor-pointer hover:underline"
//             onClick={() => setFormType('login')}
//           >
//             Back to Login
//           </p>
//         </>
//       ) : (
//         <>
//           <h2 className="text-2xl font-bold mb-6">Confirm Password Reset</h2>
//           <form onSubmit={handleResetConfirm} className="space-y-2">
//             <div className="relative">
//               <input
//                 type="text"
//                 value={verificationCode}
//                 onChange={(e) => setVerificationCode(e.target.value)}
//                 placeholder="Enter verification code"
//                 className="w-full p-3 bg-transparent border border-gray-400 rounded-full text-white text-sm placeholder-gray-500 focus:outline-none focus:border-[#22AAEE]"
//                 required
//               />
//             </div>
//             <div className="relative">
//               <input
//                 type="password"
//                 value={newPassword}
//                 onChange={(e) => setNewPassword(e.target.value)}
//                 placeholder="Enter your new password"
//                 className="w-full p-3 bg-transparent border border-gray-400 rounded-full text-white text-sm placeholder-gray-500 focus:outline-none focus:border-[#22AAEE]"
//                 required
//               />
//             </div>
//             {error && <p className="text-red-500">{error}</p>}
//             <button
//               type="submit"
//               className="w-full py-3 border border-[#22AAEE] text-[#22AAEE] font-bold rounded-full transition duration-200 hover:bg-[#22AAEE] hover:text-white"
//             >
//               Reset Password
//             </button>
//           </form>
//           <p
//             className="mt-4 text-sm cursor-pointer hover:underline"
//             onClick={() => setFormType('login')}
//           >
//             Back to Login
//           </p>
//         </>
//       )}
//     </div>
//   );
// }

// export default ResetPasswordForm;




import React, { useState } from 'react';
import axios from 'axios';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { userPool } from '../cognito/UserPool';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import Env from '../runtimeEnv';

function ResetPasswordForm({ setFormType }) {
  const [email, setEmail] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [error, setError] = useState('');
  const [formState, setFormState] = useState('resetRequest'); 
  const [showPassword, setShowPassword] = useState(false);

  // Handle reset password request
  const handleResetRequest = async (e) => {
    e.preventDefault();
    setError('');

    try {
      const response = await axios.post(`${Env.REACT_APP_PYTHON_API_URL}/api/forgot-password`, {
        email: email.trim(),
      });

      if (response.data.newTemporaryPasswordSent) {
        setError('Your temporary password has been sent to your email.');
        setFormType('login');
      } else {
        setFormState('resetConfirm'); 
      }
    } catch (err) {
      setError(`Failed to send reset code: ${err.response?.data?.message || err.message}`);
    }
  };

  // Handle reset password confirmation (for normal reset flow)
  const handleResetConfirm = (e) => {
    e.preventDefault();
    setError('');

    const cognitoUser = new CognitoUser({
      Username: email.trim(),
      Pool: userPool,
    });

    cognitoUser.confirmPassword(verificationCode.trim(), newPassword.trim(), {
      onSuccess: () => {
        setFormType('login');
      },
      onFailure: (err) => {
        setError(`Failed to reset password: ${err.message}`);
      },
    });
  };

  // Prevent space in input fields
  const preventSpace = (e) => {
    if (e.key === ' ') {
      e.preventDefault();
    }
  };

  return (
    <div className="bg-black bg-opacity-80 p-8 rounded-3xl shadow-lg w-[350px] text-white text-center">
      {formState === 'resetRequest' ? (
        <>
          <h2 className="text-2xl font-bold mb-6">Reset Password</h2>
          <form onSubmit={handleResetRequest} className="space-y-2">
            <div className="relative">
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value.trim())}
                placeholder="Enter your email"
                className="w-full p-3 bg-transparent border border-gray-400 rounded-full text-white text-sm placeholder-gray-500 focus:outline-none focus:border-[#22AAEE]"
                required
              />
            </div>
            {error && <p className="text-red-500">{error}</p>}
            <button
              type="submit"
              className="w-full py-3 border border-[#22AAEE] text-[#22AAEE] font-bold rounded-full transition duration-200 hover:bg-[#22AAEE] hover:text-white"
            >
              Send Reset Code
            </button>
          </form>
          <p
            className="mt-4 text-sm cursor-pointer hover:underline"
            onClick={() => setFormType('login')}
          >
            Back to Login
          </p>
        </>
      ) : (
        <>
          <h2 className="text-2xl font-bold mb-6">Confirm Password Reset</h2>
          <form onSubmit={handleResetConfirm} className="space-y-2">
            <div className="relative">
              <input
                type="text"
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value.trim())}
                onKeyDown={preventSpace}
                placeholder="Enter verification code"
                className="w-full p-3 bg-transparent border border-gray-400 rounded-full text-white text-sm placeholder-gray-500 focus:outline-none focus:border-[#22AAEE]"
                required
              />
            </div>
            <div className="relative">
              <input
                type={showPassword ? 'text' : 'password'}
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value.trim())}
                onKeyDown={preventSpace}
                placeholder="Enter your new password"
                className="w-full p-3 bg-transparent border border-gray-400 rounded-full text-white text-sm placeholder-gray-500 focus:outline-none focus:border-[#22AAEE]"
                required
              />
              <button
                type="button"
                className="absolute inset-y-0 right-3 flex items-center text-gray-400"
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            {error && <p className="text-red-500">{error}</p>}
            <button
              type="submit"
              className="w-full py-3 border border-[#22AAEE] text-[#22AAEE] font-bold rounded-full transition duration-200 hover:bg-[#22AAEE] hover:text-white"
            >
              Reset Password
            </button>
          </form>
          <p
            className="mt-4 text-sm cursor-pointer hover:underline"
            onClick={() => setFormType('login')}
          >
            Back to Login
          </p>
        </>
      )}
    </div>
  );
}

export default ResetPasswordForm;
